import client from '@/http'

const loadAll = (context) => {
  client.get(
    '/users'
  ).then(
    (res) => {
      context.commit('SET_USERS', res.data)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const load = (context, userId) => {
  client.get(
    `/users/${userId}`
  ).then(
    (res) => {
      context.commit('SET_USER', res.data)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const save = (context, params) => {
  if (params.id) {
    client.put(
      `/users/${params.id}`, params
    ).then(
      () => {
        context.commit('UPDATE', params)
      }
    ).catch(
      (err) => {
        console.error(err)
      }
    )
  } else {
    client.post(
      '/users', params
    ).then(
      (res) => {
        context.commit('PUSH', res.data)
      }
    ).catch(
      (err) => {
        console.error(err)
      }
    )
  }
}

const remove = (context, userId) => {
  client.delete(
    `/users/${userId}`
  ).then(
    () => {
      context.commit('REMOVE', userId)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const setScope = (context, params) => {
  client.put(
    `users/set/scope`, params
  ).then(
    () => {
      context.commit('SET_SCOPE', params)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const getAuthorisation = (context, params) => {
  client.get(
    `users/probe/bundle/${params.bundleId}`
  ).then(
    (res) => {
      context.commit('SET_AUTHORISATION', res.data)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

export default {
  save,
  load,
  remove,
  loadAll,
  setScope,
  getAuthorisation
}
